import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { FormatEnum, FormatTimeDataTypeEnum } from '@oranta-mis/sdk';
import { IFormatTimeData } from '../interfaces/booking.interface';

interface FormatTimePipeValue {
  format_time?: IFormatTimeData;
  formatTime?: IFormatTimeData;
  format: FormatEnum;
}

@Pipe({
  standalone: true,
  name: 'formatTime',
})
export class FormatTimePipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  constructor(private i18n: TranslocoHelper) {}

  transform({ format, format_time, formatTime }: FormatTimePipeValue): string {
    //тимчасово, на беку переходить на camelCase
    const timeData = format_time ?? formatTime;
    if (!timeData) {
      return '';
    }
    // ----------------------------
    return `${this.format(timeData)}&nbsp;(${this.i18n.tr(format)})`;
  }

  private format(formatValue: IFormatTimeData): string {
    if (formatValue.type === FormatTimeDataTypeEnum.by_date) {
      return `${this.transformDate(formatValue.startDate)} - ${this.transformDate(formatValue.endDate)}`;
    } else {
      return `${formatValue.duration}&nbsp;${this.i18n.tr('short_' + formatValue.durationFormat)}`;
    }
  }

  private transformDate(date: Date | null): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy') || '';
  }
}
